import RebookDly from '@/views/RebookDly/index.vue'

const RebookDlyRouter = {
  path: '/rebook-dly',
  name: 'RebookDly',
  component: RebookDly,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default RebookDlyRouter
